module.exports = __webpack_public_path__ + "static/media/sf-test-9.8f24d637.mp3";